<script setup lang="ts">
import { MultipackPickerProps } from "./MultipackPicker.props"
import { formatMoney, discountPercentage } from "~/utils/formatters"
const props = defineProps<MultipackPickerProps>()

const emit =
  defineEmits<{
    (e: "click", slug: string): void
  }>()

function handleSelect(slug: string) {
  emit("click", slug)
}

function formatQuantityLabel(quantity: number) {
  return `${quantity} confezion${quantity === 1 ? "e" : "i"}`
}

function getDiscountLabel(price: number, oldPrice: number) {
  if (!oldPrice || oldPrice <= price) {
    return ""
  }

  const discount = discountPercentage(price, oldPrice)
  return `-${discount}%`
}
</script>

<template>
  <div class="multipack-picker-wrapper flex flex-nowrap rounded-lg">
    <button
      v-for="(option, index) in props.multipackOptions"
      :key="option.slug"
      @click="() => handleSelect(option.slug)"
      type="button"
      class="relative flex flex-1 flex-col items-center border-2 text-center"
      :class="[
        option.current
          ? 'bg-orange-10 text-black-main border-orange-main z-10 cursor-not-allowed'
          : 'text-slate-40 border-black-10 z-0 cursor-pointer',
        index === 0 ? 'rounded-l-lg' : '',
        index === props.multipackOptions.length - 1 ? 'rounded-r-lg' : '',
        index > 0 ? '-ml-[2px]' : ''
      ]"
    >
      <div class="px-3 pt-2">
        <p class="mouse text-slate-main">
          {{ formatQuantityLabel(option.quantity) }}
        </p>

        <div class="flex items-center justify-center gap-2 pb-1">
          <p
            class="pig text-black-main"
            :class="{ 'pig-bold': option.current }"
          >
            {{ formatMoney(option.price) }}
          </p>
        </div>
      </div>

      <div
        v-if="getDiscountLabel(option.price, option.oldPrice)"
        class="bg-orange-10 w-full py-1 text-center"
        :class="[
          index === 0 ? 'rounded-bl-lg' : '',
          index === props.multipackOptions.length - 1 ? 'rounded-br-lg' : ''
        ]"
      >
        <p class="mouse-bold text-orange-main">
          {{ getDiscountLabel(option.price, option.oldPrice) }}
        </p>
      </div>
    </button>
  </div>
</template>
